import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const _updateRecipeIngredientList = (payload, recipes) => {
  const newRecipes = recipes.map((recipe) => {
    if (recipe._id === payload.recipe) {
      const newRecipe = Object.assign({}, recipe);
      newRecipe.ingredientList = newRecipe.ingredientList.filter(
        (ingredient) => {
          return (
            ingredient[0] !== payload.ingredient.ingredient &&
            ingredient[1] !== payload.ingredient.measurement
          );
        }
      );
      return newRecipe;
    }
    return recipe;
  });
  return newRecipes;
};

const _updateRecipeSteps = (payload, recipes) => {
  const newRecipes = recipes.map((recipe) => {
    if (recipe._id === payload.recipe) {
      const newRecipe = Object.assign({}, recipe);
      newRecipe.steps = newRecipe.steps.filter((_step) => {
        return _step !== payload.step.value;
      });
      return newRecipe;
    }
    return recipe;
  });
  return newRecipes;
};

const _updateRecipeAdmin = (payload, recipes) => {
  const newRecipes = recipes.map((recipe) => {
    if (recipe._id === payload.recipeId) {
      const newRecipe = Object.assign({}, recipe);
      if (!newRecipe.recipeAdmin) {
        newRecipe.recipeAdmin = [payload.userId];
        newRecipe.recipeAdminMap = [
          { id: payload.userId, email: payload.userEmail },
        ];
      } else {
        if (newRecipe.recipeAdmin.indexOf(payload.userId) > -1) {
          newRecipe.recipeAdmin = newRecipe.recipeAdmin.filter((adminId) => {
            return adminId !== payload.userId;
          });
          newRecipe.recipeAdminMap = newRecipe.recipeAdminMap.filter(
            (adminObj) => {
              return adminObj.id !== payload.userId;
            }
          );
        } else {
          newRecipe.recipeAdmin.push(payload.userId);
          newRecipe.recipeAdminMap.push({
            id: payload.userId,
            email: payload.userEmail,
          });
        }
      }
      return newRecipe;
    }
    return recipe;
  });
  return newRecipes;
};

export default function recipesReducer(
  state = {
    recipes: initialState.recipes,
    recipe: initialState.newRecipe,
    recipeOptions: initialState.recipeOptions,
  },
  action
) {
  switch (action.type) {
    case types.LOAD_RECIPES_SUCCESS:
      return { ...state, recipes: action.recipes };
    case types.UPDATE_RECIPE_SUCCESS:
      return {
        ...state,
        recipes: state.recipes.map((recipe) =>
          recipe._id === action.recipe._id ? action.recipe : recipe
        ),
      };
    case types.CREATE_RECIPE_SUCCESS:
      return { ...state, recipes: [...state.recipes, { ...action.recipe }] };
    case types.VERIFY_NOTHING:
      return { ...state, recipes: [...state.recipes, { lolwat: true }] };
    case types.DELETE_RECIPE_OPTIMISTIC:
      return {
        ...state,
        recipes: state.recipes.filter(
          (recipe) => recipe._id !== action.recipe._id
        ),
      };
    case types.DELETE_RECIPE_INGREDIENT_OPTIMISTIC:
      return {
        ...state,
        recipes: _updateRecipeIngredientList(action.payload, state.recipes),
      };
    case types.DELETE_RECIPE_STEP_OPTIMISTIC:
      return {
        ...state,
        recipes: _updateRecipeSteps(action.payload, state.recipes),
      };
    case types.UPDATE_RECIPE_ADMIN_OPTIMISTIC:
      return {
        ...state,
        recipes: _updateRecipeAdmin(action.payload, state.recipes),
      };
    default:
      return state;
  }
}
